/**
 *
 *  Availability Calendar
 *  TruBe Date Time AvailabilityCalendar Component
 *
 *  Created by Vladimir Shishlyannikov on 28/02/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React from "react";
import TruBeDateTimePicker from "../TruBeDateTimePicker";
import renderCalendarDay from "./renderCalendarDayRow/renderCalendarDayRow";

export default function AvailabilityCalendar(props) {
  const { focusedInput } = props;

  return (
    <TruBeDateTimePicker
      {...props}
      renderCalendarDay={(props) =>
        renderCalendarDay({
          focusedInput,
          ...props,
        })
      }
      monthStartingHeadingLevel={2}
    />
  );
}
